var _module_exports = "<iframe src=\"//player.vimeo.com/video/96578814\" width=\"800\" height=\"501\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n";;
var path = 'views/modals/tutorial_video.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;